import React, { useMemo, useEffect } from "react";

interface IServiceDetailsCardComponentProps {
    title: string;
    paras: string[];
    coverImage: string;
}

export const ServiceDetailsCardComponent: React.FC<
    IServiceDetailsCardComponentProps
> = ({ coverImage, title, paras }) => {
    // Preload image to prevent flicker
    useEffect(() => {
        if (coverImage) {
            const img = new Image();
            img.src = coverImage;
        }
    }, [coverImage]);

    // Memoized paragraphs
    const renderedParagraphs = useMemo(() => {
        return paras.map((para, index) => (
            <p
                key={index}
                data-aos="fade-up"
                data-aos-delay={200 + 100 * (index + 1)}
                dangerouslySetInnerHTML={{ __html: para }}
            ></p>
        ));
    }, [paras]);

    return (
        <div className="col-lg-12" data-aos="fade-up" data-aos-delay="100">
            <section id="blog-details" className="blog-details section">
                <div className="container">
                    <article className="article">
                        <div className="post-img">
                            <img loading="lazy"
                                src={coverImage}
                                alt="bg-cover-image"
                                style={{
                                    width: "100%",
                                    objectFit: "cover",
                                    height: "300px",
                                    transition: "opacity 0.3s ease-in-out",
                                }}
                            />
                        </div>

                        <h2 className="title" data-aos="fade-up" data-aos-delay="200">
                            {title}
                        </h2>

                        <div className="content text-justify">{renderedParagraphs}</div>
                    </article>
                </div>
            </section>
        </div>
    );
};
